import { PayloadAction } from "@reduxjs/toolkit";
import { ItemId } from "../../../../../common/models/ItemId";
import { ServiceState } from "../models/ServiceState";

const setNewItemId = (state: ServiceState, action: PayloadAction<ItemId>) => {
    state.newItemId = action.payload.id;
}

export default setNewItemId;